import { useEffect, useState } from 'react';
import { FormikErrors } from 'formik';
import { useSingleAttributeImage } from '@hooks/use-single-attribute-image';
import { AttributeFormState } from '@idw-types/state/attribute-form-state';

type HiddenAttributeImageProps = {
    onSetSubmitValue: (payload: any) => void;
    onSetPickerValue: (payload: any) => void;
    attribute: AttributeFormState;
	fieldName: string;
	setFieldValue: (field: string, value: any, shouldValidate?: boolean) => Promise<void> | Promise<FormikErrors<any>>;
};

export const HiddenAttributeImage = (props: HiddenAttributeImageProps) => {
    const {
        attribute,
		fieldName,
		setFieldValue,
        onSetSubmitValue,
        onSetPickerValue
    } = props;

	const [attributeName, setAttributeName] = useState('');
	const images = useSingleAttributeImage(
		attribute,
		attributeName,
		onSetSubmitValue,
		onSetPickerValue,
	);
	const [image] = images;

	useEffect(() => {
		if (attribute.type) {
			setAttributeName(`${attribute.type.slice(0, 1).toLowerCase()}${attribute.type.slice(1)}`);
		}
		if (image) {
			setFieldValue(`${fieldName}.${attributeName}`, image);
		} else {
			setFieldValue(`${fieldName}.${attributeName}`, '');
		}

		return () => {};
	}, [image, attribute.type]);

	return <></>;
};